import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { TacticStatus } from 'basics/enums/maya.enums';
import useTacticOptions from 'basics/options/tactic.options';
import { TacticStateType } from 'basics/types/maya.types';
import { DialogFormProps } from 'components/DialogForm/DialogForm';
import { Channel } from 'generated/maya.types';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';
import { MultiSelectYodaInputProps } from 'yoda-ui/components/Form/SelectYoda/MultiSelectYoda/MultiSelectYoda.types';

const GroupDialogFormConfig = (
  open: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  cepId: string | null,
  tacticStateValue: TacticStateType,
  handleFormSubmit: React.MouseEventHandler<HTMLButtonElement>,
  isAllowedGroupCreation: boolean,
) => {
  const { t } = useTranslation();
  const channels = Object.values(Channel).filter((channel) => channel !== Channel.group);
  const statuses = [TacticStatus.EMPTY, TacticStatus.DRAFT, TacticStatus.APPROVED];
  const onlyTacticsWithoutGroups = true;
  const tacticOptions = useTacticOptions(cepId, [], channels, statuses, onlyTacticsWithoutGroups);

  if (tacticStateValue?.tactic?._id && !tacticOptions.length) {
    tacticOptions.unshift({
      id: tacticStateValue?.tactic?._id,
      label: tacticStateValue?.tactic?.title,
      channel: tacticStateValue?.tactic?.channel,
      formattedId: tacticStateValue?.tactic?.formattedTacticId,
    });
  }

  const defaultTacticOption = tacticStateValue?.tactic ? [tacticOptions[0]] : [];

  const dialog: DialogFormProps = {
    dialogTitle: t('maya_tactic_group_dialog_title'),
    open,
    setOpen,
    onCancel: () => null,
    cancelButtonConfig: {
      buttonProps: {
        disabled: false,
        onClick: () => setOpen(false),
        buttonType: ButtonType.secondary,
      },
      label: t('maya_tactic_group_dialog_cancel_button'),
      loading: false,
      hidden: false,
    },
    submitButtonConfig: {
      buttonProps: {
        disabled: !isAllowedGroupCreation,
        onClick: handleFormSubmit,
        buttonType: ButtonType.neutral,
      },
      label: t('maya_tactic_group_dialog_create_button'),
      loading: false,
      hidden: false,
    },
    fullWidth: true,
  };

  const tacticsInGroup: MultiSelectYodaInputProps = {
    label: t('maya_tactic_group_selected_tactics_label'),
    name: 'tacticsInGroup',
    placeholder: t('maya_tactic_group_selected_tactics_placeholder'),
    options: tacticOptions,
    defaultValue: defaultTacticOption,
    required: true,
    disabled: false,
  };

  return {
    dialog,
    tacticsInGroup,
  };
};

export default GroupDialogFormConfig;
